import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const GraphBasedProtocols = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Graph Based Protocols and Tree Protocol for Concurrency Control"
    videos={[
      "https://www.youtube.com/embed/1WYGE_BBYtY?si=is386jLhqHHE1-Gc",
      "https://www.youtube.com/embed/qQq9oudwHc4?si=dKxnKo4u8xce4xSL",
      "https://www.youtube.com/embed/fGFGA7RNsEo?si=zyrYoQvAgJerVirm"
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default GraphBasedProtocols;
